(function(m,_){typeof exports=="object"&&typeof module!="undefined"?module.exports=_():typeof define=="function"&&define.amd?define(_):(m=typeof globalThis!="undefined"?globalThis:m||self,m["vue-dk-toast"]=_())})(this,function(){"use strict";function m(o){o.positionX!=="left"&&o.positionX!=="right"&&o.positionX!=="center"&&console.error(`vue-dk-toast [Error]: positionX must be either "left", "right" or "center", received "${o.positionX}"`),o.positionY!=="top"&&o.positionY!=="bottom"&&console.error(`vue-dk-toast [Error]: positionY must be either "top" or "bottom", received "${o.positionY}"`)}function _(o,i){let t=!0;return!o&&!i.slotLeft&&!i.slotRight&&!i.slot&&(console.error("vue-dk-toast [Error]: a text/slot value is required"),t=!1),i.slot&&console.warn("vue-dk-toast [Warn]: slot is now deprecated. Use slotRight instead"),t}function Y(o){let i=!1,t=!1;return o.split("").map(e=>((e==="."||e==="@"||e==="#")&&!t&&(i=!0),i&&(e===","||e==="{")&&(i=!1),e===":"&&!i&&(t=!0),e===";"&&!i&&(t=!1),(e===" "||e===`
`||e==="\r")&&!i&&!t?"":e)).join("").split(" {").join("{").split(": ").join(":")}function y(o,i){const t=o||{};let r=Object.keys(t).map(e=>{const a=e.split("").map((n,s)=>{const d=e.split("webkit")[0]==="",c=e.split("moz")[0]==="",l=e.split("ms")[0]==="";return n==="-"?n:(d||c||l)&&s===0?`-${n.toLowerCase()}`:n===n.toUpperCase()?`-${n.toLowerCase()}`:n}).join("");if(!!t)return`${a}: ${t[e]};`}).join("");return i?r+=`animation-delay: 0s, ${i/1e3-.15}s;`:r+="animation: dk__toast-in 0.15s;",r}function E(o){const{duration:i,styles:t,positionY:r}=o,e=y(t,i),a=document.createElement("style");a.type="text/css",a.textContent=Y(`
    .dk__toast-container {
      pointer-events: none;
      display: grid;
      grid-template-areas: "top-left top-center top-right" "bottom-left bottom-center bottom-right";
      grid-template-columns: repeat(3, 33%);
      grid-template-rows: repeat(2, 50%);
      gap: 10px;
      position: fixed;
      top: 0;
      left: 0;
      padding: 20px;
      height: calc(100vh - 40px);
      width: calc(100vw - 40px);
      z-index: 10000;
    }
    .dk__toast-mobile-container {
      pointer-events: none;
      visibility: hidden;
      position: fixed;
    }
    .dk__toast-section {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
    }
    .dk__toast {
      ${o.disableClick?"":"cursor: pointer;"}
      pointer-events: all;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-pack: distribute;
      justify-content: space-around;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      position: relative;
      margin: 5px 0;
      padding: 7px 40px;
      min-width: 170px;
      font: 17px Avenir, sans-serif;
      text-align: center;
      word-break: break-word;
      border-radius: 5px;
      background: #fff;
      -webkit-box-shadow: 0 1px 3px #000;
      box-shadow: 0 1px 3px #000;
      -webkit-transition: opacity 0.25s;
      -o-transition: opacity 0.25s;
      transition: opacity 0.25s;
      animation: dk__toast-in 0.15s, dk__toast-in 0.15s reverse forwards;
      ${e||""}
    }
    .dk__toast-top-left {
      grid-area: top-left;
    }
    .dk__toast-top-center {
      grid-area: top-center;
    }
    .dk__toast-top-right {
      grid-area: top-right;
    }
    .dk__toast-bottom-left {
      grid-area: bottom-left;
      justify-content: flex-end;
    }
    .dk__toast-bottom-center {
      grid-area: bottom-center;
      justify-content: flex-end;
    }
    .dk__toast-bottom-right {
      grid-area: bottom-right;
      justify-content: flex-end;
    }
    ${o.disableClick?"":".dk__toast:hover { opacity: 0.7; }"}
    .dk__icon-left,
    .dk__icon-right {
      display: flex;
      position: absolute;
      padding: 5px 12px;
    }
    .dk__icon-left {
      left: 0;
    }
    .dk__icon-right {
      right: 0;
    }
    .dk__icon-left i,
    .dk__icon-left span,
    .dk__icon-right i,
    .dk__icon-right span {
      font-size: 16px;
    }
    .dk__icon-only {
      padding: 6px 0;
    }
    .dk__icon-only .dk__icon-left,
    .dk__icon-only .dk__icon-right {
      display: flex;
      position: relative;
      right: unset;
      left: unset;
      padding: 4px;
    }
    .dk__toast.dk__click-disabled {
      cursor: default;
      opacity: 1;
    }
    .dk__toast.dk__error {
      background-color: rgb(255, 0, 0);
      color: #fff;
    }
    .dk__toast.dk__success {
      background-color: rgb(31, 218, 56);
      color: #fff;
    }
    .dk__toast.dk__passive {
      background-color: rgb(31, 59, 218);
      color: #fff;
    }
    @-webkit-keyframes dk__toast-in {
      from {
        -webkit-transform: translateY(100%);
        transform: translateY(100%);
        opacity: 0;
      }
      to {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }
    }
    @keyframes dk__toast-in {
      from {
        -webkit-transform: translateY(100%);
        transform: translateY(100%);
        opacity: 0;
      }
      to {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }
    }
    @media only screen and (max-width: 810px) {
      .dk__toast-container {
        visibility: hidden;
      }
      .dk__toast-mobile-container {
        visibility: visible;
        display: grid;
        grid-template-areas: "top" "bottom";
        grid-template-rows: 50% 50%;
        grid-template-columns: 100%;
        top: 0;
        left: 0;
        padding: 20px;
        height: calc(100vh - 40px);
        width: calc(100vw - 40px);
        z-index: 10000;
      }
      .dk__toast-mobile-top { grid-area: top; }
      .dk__toast-mobile-bottom { 
        grid-area: bottom;
        align-self: end;
      }
    }
    @media only screen and (max-width: 450px) {
      .dk__toast-section {
        right: 0;
        left: 0;
        ${r}: 10px;
        margin: 0 auto;
        width: 90%;
        transform: none;
      }
      .dk__toast {
        padding: 10px 40px;
      }
      .dk__icon-only {
        padding: 8px 30px;
      }
    }
  `),document.head.appendChild(a)}const u=[];function b(o,i,t){o.className=i,t.appendChild(o)}function L(o,i,t,r){var d,c;const e=((d=t.link)==null?void 0:d.href)?document.createElement("a"):document.createElement("div"),a=t.slotLeft,n=t.slot||t.slotRight;if((c=t.link)==null?void 0:c.href){const l=e;l.href=t.link.href,l.rel="noopener",t.link.targetBlank&&(l.target="_blank")}e.className="dk__toast",i.class&&e.classList.add(i.class),t.class&&e.classList.add(t.class),t.type&&e.classList.add(`dk__${t.type}`),e.setAttribute("role","status"),e.setAttribute("aria-live","polite"),e.setAttribute("aria-atomic","false"),o&&(e.textContent=o),a&&(e.innerHTML=`<div class="dk__icon-left">${a}</div>${e.innerHTML}`),n&&(e.innerHTML+=`<div class="dk__icon-right">${n}</div>`),!o&&(a||n)&&e.classList.add("dk__icon-only");const s=t.styles?t.styles:i.styles;return e.setAttribute("style",y(s,r)),t.disableClick&&e.classList.add("dk__click-disabled"),e}function j(o,i){const t=document.createElement("div"),r=document.createElement("div");b(t,"dk__toast-container",document.body),b(r,"dk__toast-mobile-container",document.body);function e(a,n){var w,$;const s=n||{};if(!s||!_(a,s))return;const d={y:s.positionY||i.positionY,x:s.positionX||i.positionX},c=document.querySelector(`.dk__toast-${d.y}-${d.x}`)||document.createElement("div"),l=document.querySelector(`.dk__toast-mobile-${d.y}`)||document.createElement("div"),T=document.querySelectorAll(".dk__toast").length/2;if(i.max&&T>=i.max){const f=u[0][0],C=u[0][1];(w=f.parentElement)==null||w.removeChild(f),($=C.parentElement)==null||$.removeChild(C),u.shift()}if(!c.className){const f=`dk__toast-section dk__toast-${d.y}-${d.x}`;b(c,f,t)}if(!l.className){const f=`dk__toast-mobile-section dk__toast-mobile-${d.y}`;b(l,f,r)}const g=s.duration||s.duration===!1?s.duration:i.duration,p=L(a,i,s,g),k=p.cloneNode(!0);let v;function x(f){f&&(v=!0),[...c.children].includes(p)&&c.removeChild(p),[...l.children].includes(k)&&l.removeChild(k),u.shift()}!i.disableClick&&!s.disableClick&&(p.addEventListener("click",x),k.addEventListener("click",x)),u.push([p,k]),c.appendChild(p),l.appendChild(k),!!g&&setTimeout(()=>{v||x()},g)}o.config.globalProperties.$toast=e,o.provide("$toast",e)}const h={install:(o,i)=>{const t=i||{};!t.duration&&t.duration!==!1&&(t.duration=5e3),t.positionY||(t.positionY="bottom"),t.positionX||(t.positionX="right"),m(t),E(t),j(o,t)}};return window!==void 0&&window.Vue&&(window.DKToast=h),h});
